/* eslint-disable */

import React from 'react';

const customKeypadInstructions: any = {
    l097: (<>
        Please use your fob to disarm the alarm before entering your unit, and to re-arm when you exit.
    </>),
    l174: (<>
        At the keypad, enter: <b>unit number # code *</b>
        <br/>
        For example, if your unit number is 12345 and your access code is 6789,
        you would enter: 12345#6789*{' '}
    </>),
    l176: (<>
        At the keypad, enter: <b>unit number # code *</b>
        <br/>
        For example, if your unit number is 12345 and your access code is 6789,
        you would enter: 12345#6789*{' '}
    </>),
    l267: (<>
        At the keypad, enter your access code followed by the key symbol on the keypad
        <br/>
        For example, if your access code is 1234, you would enter: 1234 and then press the key symbol{' '}
    </>),
    l289: (<>
        To access the building, tap your access pass on the black card reader.
    </>)
};

const facilitiesThatUseFob = ['L097', 'L289'];

const ClientHubAccess = (props: {
    isMobile: boolean;
    scrollTo: Function;
    activeSection: string;
    track: Function;
    facilityData: any;
    sitelinkId: string;
}) => {
    const {isMobile, scrollTo, activeSection, track, facilityData, sitelinkId} =
        props;
    const id = 'access';

    let hasAccessCode = true;
    const facilityId = facilityData?.Facility_ID;
    if (facilityId && facilitiesThatUseFob.includes(facilityId)) {
        hasAccessCode = false;
    }

    const facilityIdLowercase: string =
        facilityData?.Facility_ID?.toLowerCase() || '';

    const hasCustomInstructions = Object.keys(customKeypadInstructions).includes(
        facilityIdLowercase
    );

    const showSection = () => {
        if (isMobile) return activeSection === id;
        return true;
    };

    const getCustomKeypadInstructions = () => {
        if (hasCustomInstructions) {
            return customKeypadInstructions[facilityIdLowercase];
        }
        return <></>;
    };

    return (
        <div style={{display: showSection() ? 'block' : 'none'}}>
            <h3
                id="access"
                style={{textTransform: 'none', backgroundColor: 'aliceblue'}}
            >
                Unit access {hasAccessCode && <> & access code </>}
            </h3>
            {hasAccessCode &&
                <div>
                    {' '}
                    You must use your personal access code for both entry and exit.
                </div>
            }
            <br/>
            <div>
                { hasAccessCode &&
                    <>
                        <div>
                            <b>How to find your access code</b>
                            <br/>- Log in to{' '}
                            <a
                                style={{textDecoration: 'none'}}
                                target="_blank"
                                rel="noreferrer"
                                onClick={() => track('Open MyAccount')}
                                href={`https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=${sitelinkId}==&1=1`}
                            >
                                My Account
                            </a>{' '}
                            <br/>
                            - Select your unit <br/>
                            - The access code will appear below your contact information on the "Account Balance" page <br/>
                            - Or call us for assistance <br/>
                        </div>
                        <hr/>
                    </>
                }
                <div>
                    <b>Accessing your unit</b>
                    <br/>
                    Gate hours can be found in the{' '}
                    <a
                        href={'#'}
                        onClick={(e) => {
                            e.preventDefault();
                            scrollTo('contact');
                            return false;
                        }}
                        style={{textDecoration: 'none'}}
                    >
                        Contact
                    </a>{' '}
                    section. <br/>
                    <br/>
                    {hasCustomInstructions && getCustomKeypadInstructions()}
                    {!hasCustomInstructions && (
                        <div>
                            At the keypad, enter: <b>*code#</b> <br/>
                            For example, if your access code is 12345, you would enter:
                            *12345#{' '}
                        </div>
                    )}
                    <br/>
                </div>
            </div>
            <hr/>
            <br/>
        </div>
    );
};

export default ClientHubAccess;
